export default "__VITE_ASSET__CIP$zCRD__"